module.exports = __webpack_public_path__ + "static/media/PrimaryFunc.5057ab29.svg";